module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("l93b3"))).then(() => parcelRequire('1iHdE'));